import styled from '@emotion/styled'
import { css } from '@emotion/react'
import tw from 'twin.macro'

export const BagItemContainer = styled.li`
  ${tw`flex flex-col py-5 w-full`}
`

export const BagItemContainerRow = styled.div`
  ${tw`flex flex-row items-start`}
`

export const BagItemTitleContainer = styled.div`
  ${tw`flex flex-col flex-grow`}
`

export const BagItemQuantityContainer = styled.span`
  ${tw`mr-4 mt-1`}
`

export const BagItemTitle = styled.span`
  ${tw`pl-2`}
`
export const BagItemTitleUnavailable = styled(BagItemTitle)`
  ${tw`text-gray-400`}
`

export const BagItemSubTitle = styled.span`
  ${tw`text-sm text-grey-500 clear-left pl-2`}
`

export const TotalBagItemPrice = styled.span(
  ({ discount }) =>
    css`
      ${discount && tw`pl-3 text-grey-700`}
    `
)

export const TotalBagItemPriceUnavailable = styled(TotalBagItemPrice)`
  ${tw`text-gray-400`}
`
